module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBold.055462e6.woff2";